'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { SidenavConfig } from '../../constants/Mon569SidenavConfig';
import { Mon569TabsStickyContainer } from '../common/StickyContainer';
import SegmentedTabs from './SegmentedTabs';
import { CALYPSO } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import breakpoint from '../../utils/responsiveBreakpoints';
import H3 from 'UIComponents/elements/headings/H3';
const Header = styled(H3).withConfig({
  displayName: "StickyTabs__Header",
  componentId: "lvf8ui-0"
})(["font-weight:400;margin-bottom:0;"]);
const TabsContainer = styled(UIFlex).withConfig({
  displayName: "StickyTabs__TabsContainer",
  componentId: "lvf8ui-1"
})(["margin:auto;max-width:1200px;", ";"], breakpoint.cs(_t || (_t = _`
    display: none;
  `)));

const StickyTabs = ({
  isTabsIntersecting,
  selectedNavItem
}) => {
  if (isTabsIntersecting) return null;
  return /*#__PURE__*/_jsx(Mon569TabsStickyContainer, {
    children: /*#__PURE__*/_jsxs(TabsContainer, {
      align: "center",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: 200,
          cursor: 'pointer',
          minHeight: '55px'
        },
        onClick: () => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        }),
        children: /*#__PURE__*/_jsxs(UIFlex, {
          children: [/*#__PURE__*/_jsx(UIIcon, {
            className: "m-right-3 m-top-3",
            name: "up",
            size: "xs",
            style: {
              color: CALYPSO
            }
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Header, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "mon569.sidenav.title"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: SidenavConfig[selectedNavItem].title
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(SegmentedTabs, {
        isIntersecting: false,
        selectedNavItem: selectedNavItem
      })]
    })
  });
};

export default StickyTabs;